import { defineComponent as f, useSlots as k, computed as S, openBlock as o, createElementBlock as a, createElementVNode as l, renderSlot as d, Fragment as $, createBlock as s, unref as r, withCtx as c, createTextVNode as u, toDisplayString as g, createCommentVNode as n } from "vue";
import "./ghl-ui.es20.js";
import m from "./ghl-ui.es71.js";
const b = { class: "hl-modal-footer-actions" }, C = { class: "action-left" }, T = { class: "action-right" };
f({
  name: "UIModalFooter"
});
const h = f({
  __name: "ModalFooter",
  props: {
    id: {
      type: String,
      required: !0
    },
    positiveText: {
      type: String,
      default: ""
    },
    negativeText: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    type: {
      type: String,
      default: "primary"
    }
  },
  setup(e) {
    const v = k(), y = S(() => !!v.actionRight);
    return (t, i) => (o(), a("div", b, [
      l("div", C, [
        d(t.$slots, "actionLeft")
      ]),
      l("div", T, [
        d(t.$slots, "actionRight"),
        y.value ? n("", !0) : (o(), a($, { key: 0 }, [
          e.negativeText ? (o(), s(r(m), {
            key: 0,
            onClick: i[0] || (i[0] = (p) => t.$emit("negativeClick")),
            id: `${e.id}-btn-negative-action`
          }, {
            default: c(() => [
              u(g(e.negativeText), 1)
            ]),
            _: 1
          }, 8, ["id"])) : n("", !0),
          e.positiveText ? (o(), s(r(m), {
            key: 1,
            loading: e.loading,
            disabled: e.disabled,
            type: e.type,
            id: `${e.id}-btn-positive-action`,
            onClick: i[1] || (i[1] = (p) => t.$emit("positiveClick"))
          }, {
            default: c(() => [
              u(g(e.positiveText), 1)
            ]),
            _: 1
          }, 8, ["loading", "disabled", "type", "id"])) : n("", !0)
        ], 64))
      ])
    ]));
  }
}), E = h;
export {
  E as default
};
